import { createContext, useState } from "react";
import { PiNutFill } from "react-icons/pi";

export const RegisterIdContext = createContext(null); // Ensure it is exported

export const RegisterIdProvider = ({ children }) => {
  const [registerId, setRegisterid] = useState(null);
  const [violation, setViolationData] = useState("");
  const [markerLoc, setMarkerLoc] = useState(null);
  const [groupName, setGroupName] = useState(null);
  const [groupInfo, setGroupInfo] = useState(null);
  const [sic_code, setSicCodeContext] = useState(null);
  const [industry, setIndurstryContext] = useState(null);
  const [state, setStateContext] = useState(null);
  const [county, setCountyContext] = useState(null);
  const [countyObj, setCountyObjContext] = useState({});
  const [city, setCityContext] = useState(null);
  const [cityObj, setCityObjContext] = useState({});
  const [register_Id, setRegisteridContext] = useState(null);
  const [cityLat, setCityLat] = useState(null);
  const [cityLng, setCityLng] = useState(null);
  const [stateLat, setStateLat] = useState(null);
  const [stateLng, setStateLng] = useState(null);
  const [countyLat, setCountyLat] = useState(null);
  const [countyLng, setCountyLng] = useState(null);
  const [facLat, setFacLat] = useState(null);
  const [facLng, setFacLng] = useState(null);
  const [showFilterBar, setShowFilterBar] = useState(true);
  const [messages, setMessages] = useState([]);
  const [moveToBottom, setMoveToBottom] = useState(false);
  const [showWelcome, setShowWelcome] = useState(true);
  const [stateLatBld, setStateLatBld] = useState(null);
  const [stateLngBld, setStateLngBld] = useState(null);
  const [cityLatBld, setCityLatBld] = useState(null);
  const [cityLngBld, setCityLngBld] = useState(null);
  const [bldLat, setBldLat] = useState(null);
  const [bldLng, setBldLng] = useState(null);
  const [bldType, setBuildingTypeContext] = useState(null);
  const [bldOwner, setOwnerNameContext] = useState(null);
  const [bldMasterId, setBuildingNameContext] = useState(null);
  const [bldScore, setEnergyScoreContext] = useState(null);
  const [fetchSessionsFn, setFetchSessionsFn] = useState(null);
  const [facName, setFacName] = useState(null);
  const [projectId, setProjectId] = useState(null);



  const [npdesOptions, setNpdesOptions] = useState([]);
  const [selectedNpdesId, setSelectedNpdesId] = useState(null);
  const [facilityKpis, setFacilityKpis] = useState(null);
  const [structuredViolations, setStructuredViolations] = useState([]);
  const [enforcementData, setEnforcementData] = useState(null);
  const [selectedRegistryId, setSelectedRegistryId] = useState(null);
  const [floorArea, setFloorAreaContext] = useState('');
  const [EUI, setEUIContext] = useState('');

  const [buildingData, setBuildingData] = useState([]);
  //IIR Data Context Start
  const [projectList, setProjectList] = useState([]);
  const [status, setStatus] = useState(null);
  const [oppProjects, setOppProjects] = useState([]);
  const [plantDetails, setPlantDetails] = useState([]);
  const [plantOptions, setPlantOptions] = useState([]);
  const [selectedPlantId, setSelectedPlantId] = useState("");
  const [selectedPlant, setSelectedPlant] = useState({}); // Store full plant object (with contacts)
  const [selectedPlantMarker, setSelectedPlantMarker] = useState(null);


  // Refine Search Modal state
  const [isRefineSearchModalVisible, setRefineSearchModalVisible] = useState(false);
  const [selectedRefineMenu, setSelectedRefineMenu] = useState("IIR Data Source");
  const [refineSearchActive, setRefineSearchActive] = useState(false);
  const [refineSearchPlantFiltersData, setRefineSearchPlantFiltersData] = useState({});
  const [refineSearchEPAFiltersData, setRefineSearchEPAFiltersData] = useState({});
  const [refineSearchPlantID, setRefineSearchPlantID] = useState(null);
  const [isFacilitiesEmpty, setIsFacilitiesEmpty] = useState(false);
  const [plantObject, setPlantObject] = useState([])
  const [tableFacilityObject, setTableFacilityObject] = useState([])
  const [refineSearchProjectFiltersData, setRefineSearchProjectFiltersData] = useState({});
  const [activeRefineSearchType, setActiveRefineSearchType] = useState(null)
  const [activeMarkers, setActiveMarkers] = useState([]);;
  const [facilityGroupName, setfaciltyGroupName] = useState(null)
  //hide project table
  const [showProjectTable, setShowProjectTable] = useState(true);



  return (
    <RegisterIdContext.Provider
      value={{
        registerId,
        setRegisterid,
        violation,
        setViolationData,
        markerLoc,
        setMarkerLoc,
        groupName,
        setGroupName,
        sic_code,
        setSicCodeContext,
        industry,
        setIndurstryContext,
        state,
        setStateContext,
        county,
        setCountyContext,
        city,
        setCityContext,
        register_Id,
        setRegisteridContext,
        cityLat,
        setCityLat,
        cityLng,
        setCityLng,
        stateLat,
        setStateLat,
        stateLng,
        setStateLng,
        countyLat,
        setCountyLat,
        countyLng,
        setCountyLng,
        facLat,
        setFacLat,
        facLng,
        setFacLng,
        showFilterBar,
        setShowFilterBar,
        messages,
        setMessages,
        moveToBottom,
        setMoveToBottom,
        showWelcome,
        setShowWelcome,
        groupInfo, setGroupInfo,
        stateLatBld, setStateLatBld,
        stateLngBld, setStateLngBld,
        cityLatBld, setCityLatBld,
        cityLngBld, setCityLngBld,
        bldLat, setBldLat,
        bldLng, setBldLng,
        bldType, setBuildingTypeContext,
        bldOwner, setOwnerNameContext,
        bldMasterId, setBuildingNameContext,
        bldScore, setEnergyScoreContext,
        fetchSessionsFn,
        setFetchSessionsFn,
        countyObj, setCountyObjContext,
        cityObj, setCityObjContext,
        facName,
        setFacName,
        npdesOptions, setNpdesOptions,
        selectedNpdesId, setSelectedNpdesId,
        facilityKpis, setFacilityKpis,
        structuredViolations, setStructuredViolations,
        enforcementData, setEnforcementData,
        selectedRegistryId, setSelectedRegistryId,
        floorArea, setFloorAreaContext,
        EUI, setEUIContext,
        buildingData, setBuildingData,
        projectList, setProjectList,
        projectId, setProjectId,
        status, setStatus,
        oppProjects, setOppProjects,
        plantDetails, setPlantDetails,
        plantOptions, setPlantOptions,
        selectedPlantId, setSelectedPlantId,
        selectedPlant, setSelectedPlant,

        refineSearchEPAFiltersData, setRefineSearchEPAFiltersData,
        isRefineSearchModalVisible, setRefineSearchModalVisible,
        selectedRefineMenu, setSelectedRefineMenu,
        refineSearchActive, setRefineSearchActive,
        refineSearchPlantFiltersData, setRefineSearchPlantFiltersData,
        refineSearchPlantID, setRefineSearchPlantID,
        isFacilitiesEmpty, setIsFacilitiesEmpty,
        plantObject, setPlantObject,
        tableFacilityObject, setTableFacilityObject,
        refineSearchProjectFiltersData, setRefineSearchProjectFiltersData,
        activeRefineSearchType, setActiveRefineSearchType,
        activeMarkers, setActiveMarkers,
        selectedPlantMarker, setSelectedPlantMarker,
        facilityGroupName, setfaciltyGroupName,
        showProjectTable, setShowProjectTable
      }}
    >
      {children}
    </RegisterIdContext.Provider>
  );
};
